import React, { Component } from 'react';

// Routing
import routes from '~/apiRouter';

// Components
import Loader from '~/components/ui/Loader';
import PlaybillFilter from '~/components/playbill/Filter';
import PlaybillContent from '~/components/playbill/Content';

// Config and data
import filters from '~/data/playbillFilters';
import { onlineCityCode } from '~/data/fakeCities';

// Metrika
import metrikaGoal from '~/helpers/metrikaGoal';
import analyticsWidgetsUsing from '~/helpers/analyticsWidgetsUsing';
import { filterAvailableOnlineEvents } from '~h/eventFilters';
import { getCityKLADRByName, getCurrentCity } from '~h/cityCodes';

const delimiter = '*';

export default class Playbill extends Component {
  state = {
    data: [],
    filteredData: [],
    filter: [],
    loading: true,
    error: null,
    showCount: 12,
  };

  async componentDidMount() {
    metrikaGoal('conversion-playbill-open');
    analyticsWidgetsUsing('Расписание');
    setTimeout(() => {
      metrikaGoal('conversion-playbill-read');
      metrikaGoal('conversion-search-read');
    }, 30000);

    const { filters, data } = await this.loadData();
    const currentKLADR = this.getCurrentCityKLADRWithURL();
    const availableData = filterAvailableOnlineEvents(data, currentKLADR);
    this.updateFiltersByURL(filters, availableData);
  }

  getCurrentCityKLADRWithURL = () => {
    const params = this.parseURL();
    return getCityKLADRByName(params.cities?.[0]) ?? getCurrentCity().KLADR;
  };

  updateFiltersByURL = (filters, data) => {
    const params = this.parseURL();
    const newFilters = filters.map(filter => {
      const newValue =
        filter.name === 'dateFrom'
          ? new Date(Number(params[filter.name]) || filter.value)
          : params[filter.name];
      return { ...filter, value: newValue ?? filter.value };
    });

    const newFilteredData = this.filterData(newFilters, data);
    const updatedFilters = this.prepareFilter(newFilteredData);
    const selectedFilters = updatedFilters.map(filter => {
      const newValue =
        filter.name === 'dateFrom'
          ? new Date(Number(params[filter.name]) || filter.value)
          : params[filter.name];
      return { ...filter, value: newValue ?? filter.value };
    });

    this.setState({ filter: selectedFilters, filteredData: newFilteredData });
  };

  parseURL = () => {
    const urlParams = window.location.search.slice(1).split('&');
    const params = urlParams.reduce((acc, param) => {
      const type = param.match(/.+(?==)/g)?.[0];
      const encodedParams = param
        .replace(type, '')
        .slice(1)
        .split(delimiter);
      acc[type] = encodedParams.map(param => decodeURI(param));
      return acc;
    }, {});

    return params;
  };

  prepareData(data) {
    const cards = [];
    data = data.filter(
      c =>
        c.SHORT_NAME &&
        !c.HIDDEN &&
        (c.CITY != null || c.CITY_CODE == onlineCityCode),
    );
    data.forEach(c => {
      if (c.START_DATE) {
        // Стандартная карточка с датой старта
        cards.push({
          id: `${c.CODE}`,
          dateFrom: new Date(c.START_DATE),
          productCard: false,
          ...c,
        });
      } else {
        // Постоянное мероприятие без даты старта
        cards.push({
          id: `${c.CODE}`,
          dateFrom: new Date('2000-01-01'),
          productCard: true,
          ...c,
        });
      }
    });

    cards.sort((a, b) => {
      return a.dateFrom - b.dateFrom;
    });

    return cards;
  }

  prepareFilter(data) {
    const filterOptions = { type: [], course: [], cities: [], forwho: [] };

    // Part 1 - prepare options
    data = data.filter(c => c.SHORT_NAME && c.CITY != null);
    data.forEach(c => {
      // Тип программы
      if (
        c.PRODUCT_LINE &&
        filterOptions.type.indexOf(c.PRODUCT_LINE.NAME) === -1
      ) {
        filterOptions.type.push(c.PRODUCT_LINE.NAME);
      }
      // Курс
      if (
        c.DISCIPLINE &&
        filterOptions.course.indexOf(c.DISCIPLINE.NAME) === -1
      ) {
        filterOptions.course.push(c.DISCIPLINE.NAME);
      }
      // Для кого
      if (c.EVENT_PAGE?.FOR_WHOM) {
        filterOptions.forwho = filterOptions.forwho.concat(
          c.EVENT_PAGE.FOR_WHOM,
        );
      }
    });

    // Unique for
    filterOptions.forwho = [...new Set(filterOptions.forwho)];

    // Part 2 - set options to filter
    const filtersCopy = JSON.parse(JSON.stringify(filters));
    const date = filtersCopy.find(filter => filter.name === 'dateFrom');
    date.value = new Date(date.value);
    const newFilters = filtersCopy.map(f => {
      if (filterOptions[f.name]) {
        const newOptions = filterOptions[f.name].map(o => {
          return { label: o, value: o };
        });
        f.options = f.options.slice(0).concat(newOptions);
      }
      return f;
    });

    return newFilters;
  }

  async loadData() {
    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    headers.credentials = 'include';
    return await fetch(routes.playbill.get, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          // TODO: Need to refactor
          const filter = this.prepareFilter(response.data.EVENTS);
          const newData = this.prepareData(response.data.EVENTS);

          this.setState({
            data: newData || [],
            filteredData: this.filterData(filter, newData) || [],
            filter: filter || [],
            loading: false,
          });

          return { filters: filter, data: newData };
        } else {
          this.setState({
            error: response.errors || ['Ошибка загрузки данных расписания'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка загрузки расписания с сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  loadDevData() {
    // const filter = this.prepareFilter(playbill.data.EVENTS);
    // const newData = this.prepareData(playbill.data.EVENTS);
    // this.setState({
    //   data: newData || [],
    //   filteredData: this.filterData(filter, newData) || [],
    //   filter: filter || [],
    //   loading: false,
    // });
  }

  filterData(filter, newData = null) {
    // TODO: need to refactoring
    const { data } = this.state;
    if (newData == null) {
      newData = data;
    }

    // Filter values
    const online = filter.filter(f => f.name == 'online')[0].value;
    const type = filter.filter(f => f.name == 'type')[0].value;
    const course = filter.filter(f => f.name == 'course')[0].value;
    const cities = filter.filter(f => f.name == 'cities')[0].value;
    const forwho = filter.filter(f => f.name == 'forwho')[0].value;
    const dateFrom = filter.filter(f => f.name == 'dateFrom')[0].value;

    const filteredData = newData
      .filter(
        event =>
          !online.length ||
          // filter online
          (online.includes('Online') &&
            event.CITY_CODE === onlineCityCode &&
            !event.productCard) ||
          // filter face-to-face
          (online.includes('Face-to-face') &&
            event.CITY_CODE != onlineCityCode) ||
          // filter elearning
          (online.includes('Elearning') && event.productCard),
      )
      .filter(event => {
        return (
          forwho?.includes('All') ||
          forwho?.some(forWhoItem =>
            event.EVENT_PAGE?.FOR_WHOM?.includes(forWhoItem),
          )
        );
      })
      .filter(
        event =>
          type?.includes('All') ||
          type?.some(typeItem => event.PRODUCT_LINE?.NAME === typeItem),
      )
      .filter(
        event =>
          course?.includes('All') ||
          course?.some(typeItem => event.DISCIPLINE?.NAME === typeItem),
      )
      .filter(event => dateFrom <= event?.dateFrom || event.productCard)
      .filter(
        event =>
          event.CITY?.NAME === cities ||
          event.CITY?.NAME === cities?.[0] ||
          event.CITY_CODE === onlineCityCode,
      );

    return filterAvailableOnlineEvents(
      filteredData,
      getCityKLADRByName(cities?.[0] || cities),
    );
  }

  changeFilter(name, val) {
    analyticsWidgetsUsing('Фильтры расписания');

    const { filter } = this.state;
    const newFilter = filter.map(f => {
      if (f.name == name) {
        if (f.name == 'online') {
          if (f.value.includes(val)) {
            f.value.splice(f.value.indexOf(val), 1);
          } else {
            f.value.push(val);
          }
        } else {
          f.value = val;
        }
      }
      return f;
    });

    const reducedFilter = this.getUpdateFilters(this.filterData(newFilter), {
      name,
      value: val,
    });

    this.updateURLbyFilters();

    this.setState({
      filter: reducedFilter,
      filteredData: this.filterData(newFilter),
      showCount: 12,
    });
  }

  updateURLbyFilters = () => {
    const { filter: filters } = this.state;

    const newParams = filters
      .map(filter => {
        return filter.name === 'dateFrom'
          ? `${filter.name}=${new Date(filter.value).getTime()}`
          : `${filter.name}=${filter.value.join(delimiter)}`;
      })
      .join('&');
    const { origin, pathname } = window.location;
    const newURL = `${origin}${pathname}?${newParams}`;
    window.history.replaceState('page', 'Title', newURL);
  };

  getUpdateFilters(filteredData, params) {
    const newFilters = this.state.filter.slice(0);
    const uniqueTypeOptionsValues = new Set();
    const uniqueCourseOptionsValues = new Set();
    const uniqueForWhoOptionsValues = new Set();

    filteredData.forEach(event => {
      if (event.PRODUCT_LINE?.NAME)
        uniqueTypeOptionsValues.add(event.PRODUCT_LINE?.NAME);
      if (event.DISCIPLINE?.NAME)
        uniqueCourseOptionsValues.add(event.DISCIPLINE?.NAME);
      event.EVENT_PAGE?.FOR_WHOM?.forEach(item =>
        uniqueForWhoOptionsValues.add(item),
      );
    });

    const newTypeOptions = [{ label: 'Все типы', value: 'All' }].concat(
      Array.from(uniqueTypeOptionsValues).map(value => ({
        label: value,
        value,
      })),
    );

    const newCourseOptions = [{ label: 'Все курсы', value: 'All' }].concat(
      Array.from(uniqueCourseOptionsValues).map(value => ({
        label: value,
        value,
      })),
    );

    const newForWhoOptions = [{ label: 'Для всех', value: 'All' }].concat(
      Array.from(uniqueForWhoOptionsValues).map(value => ({
        label: value,
        value,
      })),
    );

    // function setFilterOptions(type, filter, options) {
    //   const filterCopy = filter.slice(0);
    //   const newFilterIndex = filter.findIndex( item => item.type === type);
    //   const newFilter = Object.assign( {}, filterCopy[newFilterIndex] );
    //   newFilter.options = options;
    //   filterCopy[newFilterIndex] = newFilter;
    //   return filterCopy;
    // }
    //
    // function updateFilters(filters) {
    //   if (params.name !== "type" || (params.name === "type" && params.value === 'All'))
    //     return  setFilterOptions(params.name, filters, newTypeOptions);
    //   // if (params.name !== "course" || (params.name === "course" && params.value === 'All')) newFilters[1].options = newCourseOptions;
    //   if (params.name !== "course" || (params.name === "course" && params.value === 'All'))
    //     return setFilterOptions(params.name, filters, newCourseOptions);
    // }

    // TODO: find options for a search, not direct index
    if (
      params.name !== 'type' ||
      (params.name === 'type' && params.value === 'All')
    )
      newFilters[0].options = newTypeOptions;
    if (
      params.name !== 'course' ||
      (params.name === 'course' && params.value === 'All')
    )
      newFilters[1].options = newCourseOptions;
    if (
      params.name !== 'forwho' ||
      (params.name === 'forwho' && params.value === 'All')
    )
      newFilters[3].options = newForWhoOptions;

    return newFilters;
  }

  render() {
    const { filter, filteredData, loading, error, showCount } = this.state;
    if (loading) return <Loader />;

    if (error) {
      // TODO: почистить лишнюю семантику
      const errors = error.map((e, index) => {
        return (
          <p key={`err_${index}`} className="txt txt--center txt--red">
            {e}
          </p>
        );
      });
      return (
        <section className="section section--schedule section--pb-lg">
          <div className="container">
            <div className="cards cards--line cards--line_orange cards--inner cards--border">
              <ul className="cards__items">{errors}</ul>
            </div>
          </div>
        </section>
      );
    }

    return (
      <React.Fragment>
        <PlaybillFilter
          filters={filter}
          onChange={(name, val) => this.changeFilter(name, val)}
        />
        <PlaybillContent
          filter={filter}
          data={filteredData}
          count={showCount}
          increaseCount={() => this.setState({ showCount: showCount + 120 })}
        />
      </React.Fragment>
    );
  }
}
